import Model, { attr } from '@ember-data/model';

import type { DateRangeInterface, Slack } from 'webapp-types';
import { ScorecardType } from 'webapp/enums/enums';

export default class ScorecardRecord extends Model {
	@attr('string') title!: string;
	@attr('string') color!: string;
	@attr('number') created!: number;
	@attr('number') createdBy!: number;
	@attr('number') blockId!: number | null;
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	delivery!: number[];
	@attr('object', {
		defaultValue() {
			return {};
		},
	})
	dateRange!: DateRangeInterface.FormulaInterface;
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	slackChannels!: Slack.Channel[];
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	userIds!: number[];
	@attr('number') originateFrom!: number | null;
	@attr('boolean') addNewUsersToDelivery!: boolean;
	@attr('number', { defaultValue: 3 }) scheduleType!: number;
	@attr('number', { defaultValue: 9 }) scheduleHourOfDay!: number | null; // null when BE sends none
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	scheduleDayOfWeek!: number[];
	@attr('number', { defaultValue: 1 }) scheduleDayOfMonth!: number | null; // null when BE sends none
	@attr('number') cloneFrom!: number | null;
	@attr('boolean') active!: boolean;
	@attr('number', { defaultValue: ScorecardType.SCORECARD }) type!: number;
}
